import plans from "../../data/plans";
import MembershipCard from "../common/MembershipCard";
import SectionHeading from "../common/SectionHeading";
import "./MembershipSection.css";

export default function MembershipSection() {
  return (
    <section className="membership-section section">
      <div className="container">
        <SectionHeading
          eyebrow="Membership Plans"
          title="Pick your"
          highlight="commitment"
          description="Straightforward plans, no hidden clauses. Contact us for current pricing and offers."
          align="center"
        />
        <div className="membership-section__grid">
          {plans.map((plan) => (
            <MembershipCard plan={plan} key={plan.id} />
          ))}
        </div>
      </div>
    </section>
  );
}
